
import clsx from 'clsx'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Text } from '../../../../ui'

const RowToggle = ({ isExpanded, onClick, showLabel = true }) => {
    return (
        <div className="flex h-full items-center justify-center space-x-3">
            <div className="flex flex-col text-xs text-gray-500 items-center justify-center">
                <div
                    className={clsx(
                        'flex text-slate-400 shadow-full-xs rounded-full items-center justify-center w-8 h-8 hover:cursor-pointer transition-all duration-200 hover:bg-white hover:shadow-md',
                        {
                            'bg-white text-blue-500': isExpanded,
                            'bg-[#fff]': !isExpanded,
                        }
                    )}
                    onClick={(e) => {
                        e.stopPropagation()
                        onClick(e)
                    }}
                >
                    <KeyboardArrowDownIcon
                        className={clsx('transition-transform duration-200', {
                            'rotate-180': isExpanded
                        })}
                    />
                </div>
                {showLabel && (
                    <Text className="mt-2 text-[10px]">{isExpanded ? 'Ocultar' : 'Ver Detalle'}</Text>
                )}
            </div>
        </div>
    )
}

export default RowToggle
